module.exports = __webpack_public_path__ + "static/img/遂宁市委常委.42d415a3.jpg";